import { fetch, responseInterceptor } from 'libs/fetch';

interface APIJSON<T> {
  code: number;
  message: string;
  data?: T;
}

type FetchPromise<T> = Promise<APIJSON<T> | undefined>;

export function materialsSearch(json: any): FetchPromise<{
  type: number;
  spuList: any[];
  totalPage: number;
  brandList: any;
  spuAttributeList: any;
  hotCategoryList: any;
  categoryList: any;
  upstreamSupplierList: any;
  searchPriceFlag: boolean;
}> {
  return fetch('/api/mall/v1/h5Sku/searchMallSkuList', {
    method: 'POST',
    json,
  });
}

export function categoryList(json?: any): FetchPromise<any> {
  return fetch('/api/mall/v1/category/list', {
    method: 'POST',
    json,
  });
}

export function apiSupplierGetLastV2(json?: any): FetchPromise<any> {
  return fetch('/api/supplier/v2/basis/supplier/getLatestSupplier', {
    method: 'GET',
    json,
  });
}

export function apiSupplierSearchV2(json?: any): FetchPromise<any> {
  return fetch('/api/supplier/v2/basis/supplier/querySupplierList', {
    method: 'POST',
    json,
  });
}

export function apiGetSupplierContract(query?: any): FetchPromise<any> {
  return fetch('/api/basic/v1/scm/project/getSupplierContract', {
    method: 'POST',
    query,
  });
}

export function apiSupplierSearch(json?: any): FetchPromise<any> {
  return fetch('/api/tender/v1/supplier/search', {
    method: 'POST',
    json,
  });
}
export function apiQueryInformation(query?: any): FetchPromise<any> {
  return fetch('/api/tender/v1/concrete/queryInformation', {
    method: 'get',
    query,
  });
}
export function apiQueryIsPushYT(query?: any): FetchPromise<any> {
  return fetch('/api/mall/v1/purchaser/trade/checkProjectPushYT', {
    method: 'get',
    query,
  });
}
export function apiQuerySubcontractorContacter(query?: any): FetchPromise<any> {
  return fetch('/api/tender/v1/concrete/querySubcontractorContacter', {
    method: 'get',
    query,
  });
}
export function apiQueryPurchaseContractByConsortiumContract(json?: any): FetchPromise<any> {
  return fetch(
    '/api/tender/v1/purchaser/contract/supplyChain/queryPurchaseContractByConsortiumContract',
    {
      method: 'POST',
      json,
    },
  );
}
export function apiGeneratePurchaseContractByConsortiumContract(json?: any): FetchPromise<any> {
  return fetch(
    '/api/tender/v1/purchaser/contract/supplyChain/generatePurchaseContractByConsortiumContract',
    {
      method: 'POST',
      json,
    },
  );
}
export function apiQueryPurchaseContractByFrameworkAgreement(json?: any): FetchPromise<any> {
  return fetch(
    '/api/tender/v1/purchaser/contract/supplyChain/queryPurchaseContractByFrameworkAgreement',
    {
      method: 'POST',
      json,
    },
  );
}
export function apiGeneratePurchaseContractByFrameworkAgreement(json?: any): FetchPromise<any> {
  return fetch(
    '/api/tender/v1/purchaser/contract/supplyChain/generatePurchaseContractByFrameworkAgreement',
    {
      method: 'POST',
      json,
    },
  );
}
export function apiSearchWzgjTagByName(): FetchPromise<any> {
  return fetch('/api/material/v1/categoryWzgjTag/searchWzgjTagByName', {
    method: 'get',
  });
}

export function apiQueryIsSelfSupplier(query?: any): FetchPromise<any> {
  return fetch('/api/ifs/v1/basis/organization/isSelfSupplier', {
    method: 'get',
    query,
  });
}

export function apiQueryHasPilotPermission(organizationSysNo): FetchPromise<any> {
  return fetch(`/api/tender/v1/dataPermission/${organizationSysNo}/hasPilotPermission`, {
    method: 'POST',
    json: ['TENDER_PURCHASER_ORDER_TRADE_EDIT', 'TENDER_PURCHASER_ORDER_CONTRACT_BIND_VIEW'],
  });
}

export async function getProductDetail(json?: any) {
  return await fetch('/api/mall/v1/h5Sku/getSkuDetail', {
    method: 'POST',
    json,
  });
}

export async function getAgreementDetail(sysNo: string) {
  return await fetch(`/api/mall/v1/trade-agreement/purchaser/ec/detail/${sysNo}`, {
    method: 'GET',
    wantError: true,
  });
}

export async function getAgreementDetailSupplier(sysNo: string) {
  return await fetch(`/api/mall/v1/trade-agreement/supplier/ec/${sysNo}`, {
    method: 'GET',
    wantError: true,
  });
}

export async function getAgreementLogDetail(sysNo: string) {
  return await fetch(`/api/mall/v1/trade-agreement/purchaser/log/ec/${sysNo}`, {
    method: 'GET',
    wantError: true,
  });
}

export async function getAgreementLogDetailSupplier(sysNo: string) {
  return await fetch(`/api/mall/v1/trade-agreement/supplier/log/ec/${sysNo}`, {
    method: 'GET',
    wantError: true,
  });
}

export function getAgreementInfo(sysNo): FetchPromise<any> {
  return fetch(`/api/mall/v1/trade-agreement/purchaser/password-info/${sysNo}`, {
    method: 'GET',
  });
}

/**
 * 获取交易规则列表
 * @param options
 */
export async function getAgreementLsit<T = any>(json) {
  const res = await fetch<T>('/api/mall/v1/h5Sku/searchPurchaseAgreementList', {
    method: 'POST',
    json,
  });
  return res;
}

export async function getBuyMoreSku(json) {
  return await fetch('/api/mall/v1/h5Sku/getBuyMoreSku', {
    method: 'POST',
    json,
  });
}

/**
 *
 * 获取收货地址列表
 */
export function searchReceiveAddress(json: {
  pageNo?: number;
  pageSize?: number;
}): FetchPromise<any> {
  return fetch('/api/tender/v1/receiveAddress/search', {
    method: 'post',
    json,
  }) as any;
}

export function saveReceiveAddress(json: any): FetchPromise<any> {
  return fetch('/api/tender/v1/receiveAddress/save', {
    method: 'post',
    json,
  }) as any;
}

export function removeReceiveAddress(json: any): FetchPromise<any> {
  return fetch('/api/tender/v1/receiveAddress/delete', {
    method: 'post',
    json,
  }) as any;
}

export function getReceiveAddressDetail<T = any>(sysNo: string): FetchPromise<T> {
  return fetch(`/api/tender/v1/receiveAddress/get/${sysNo}`, {
    method: 'GET',
  });
}

export function hotSearch(json): FetchPromise<any> {
  return fetch(`/api/mall/v1/hotWord/get`, {
    method: 'POST',
    json,
  });
}

export function shopList(json): FetchPromise<any> {
  return fetch(`/api/mall/v1/shop/getShopList`, {
    method: 'POST',
    json,
  });
}

/**
 *
 * 项目发票查询
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function invoiceSearch(json: object): FetchPromise<any> {
  return fetch('/api/ifs/v1/basisOrganizationInvoice/search', {
    method: 'post',
    json,
  });
}

/**
 * 项目发票
 *
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function invoiceGet(sysNo: any): FetchPromise<any> {
  return fetch(`/api/ifs/v1/basisOrganizationInvoice/get/${sysNo}`, {
    method: 'get',
  });
}

/**
 * 项目发票更新
 *
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function invoiceUpdate(json: {}): FetchPromise<any> {
  return fetch('/api/ifs/v1/basisOrganizationInvoice/update', {
    method: 'post',
    json,
  });
}

/**
 * 新增项目发票
 *
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function invoiceAdd(json: {}): FetchPromise<any> {
  return fetch('/api/ifs/v1/basisOrganizationInvoice/add', {
    method: 'post',
    json,
  });
}

/**
 * 删除项目发票
 *
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function invoiceDelete(json: {}): FetchPromise<any> {
  return fetch('/api/ifs/v1/basisOrganizationInvoice/delete', {
    method: 'post',
    json,
  });
}

/**
 * 获取所属组织
 * @param json
 * @returns
 */
export async function getOrganizationList(json: {}) {
  const res = await fetch('/api/ifs/v1/basis/organization/searchListByAuthKey', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 获取最近访问项目
 * @param json
 * @returns
 */
export async function getLastProject() {
  const res = await fetch('/api/tender/v1/tenderProject/getLastProject', {
    method: 'GET',
  });
  return res;
}

/**
 * 获取项目
 * @param json
 * @returns
 */
export async function getTenderProject(json: {}) {
  const res = await fetch('/api/tender/v1/tenderProject/searchList', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 获取审批流=流程列表
 *
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function availableBusinessFlowList(json: {}): FetchPromise<any> {
  return fetch('/api/workflow/flow/availableBusinessFlowList', {
    method: 'post',
    json,
  });
}
/**
 *
 * 查询是否走见证宝支付流程
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function orderTradeToPay(json: {}): FetchPromise<any> {
  return fetch('/api/tender/v1/purchaser/orderTrade/mall/toPay', {
    method: 'post',
    json,
  });
}
/**
 * 获取见证宝配置
 *
 * @export
 * @return {*}  {FetchPromise<any>}
 */
export function getJzbBusinessConfig(): FetchPromise<any> {
  return fetch('/api/financial/v1/financing/payment/config/getJzbBusinessConfig', {
    method: 'get',
  });
}
/**
 *  去支付-现金 & 线下支付（不需要走见证宝在线支付）
 *
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function getShopBankAccount(json: {}): FetchPromise<any> {
  return fetch('/api/mall/v1/purchaser/trade/getShopBankAccount', {
    method: 'post',
    json,
  });
}

/**
 * 创建订单
 *
 * @export
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function createShop(json: {}): FetchPromise<any> {
  return fetch('/api/mall/v1/purchaser/trade/createShop', {
    method: 'post',
    json: {
      ...json,
      clientType: 1, // null/1 = PC 2 = mobile
    },
  });
}

/**
 * 项目是否支持融资
 *
 * @export
 * @param {string} projectSysNo
 * @param {{}} json
 * @return {*}  {FetchPromise<any>}
 */
export function checkFactorProjectApply(json: {
  organizationSysNo: string;
  projectSysNo: string;
}): FetchPromise<any> {
  return fetch('/api/mall/v1/purchaser/trade/checkFactorProjectApply', {
    method: 'POST',
    json,
  });
}

export function getMmuSkuList(json: any): FetchPromise<MmuSkuListRes> {
  return fetch('/api/mall/v1/mallSku/getSkuList', {
    method: 'POST',
    json,
  });
}

export function getNetPriceDetail(json: any): FetchPromise<any> {
  return fetch('/api/mall/v1/trade-agreement/trade-agreement/net-price-detail', {
    method: 'POST',
    json,
  });
}

export function getShopOrganizationTree(json): FetchPromise<any> {
  return fetch(`/api/mall/v1/purchaser/trade/getShopOrganizationTree`, {
    method: 'POST',
    json,
  });
}

export function apiQueryPouringType(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/concrete/queryPouringType`, {
    method: 'POST',
    json,
  });
}

export function searchUseLocation(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/backGroundOrderTrade/searchUseLocation`, {
    method: 'POST',
    json,
  });
}

export function apiChangeMatchContractItem(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/backGroundOrderTrade/changeMatchContractItem`, {
    method: 'POST',
    json,
  });
}

export function apiQueryContractDetail(contractSysNo): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/contract/supplyChain/detail/${contractSysNo}`, {
    method: 'get',
  });
}

export function apiManualMatchPlanItem(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/backGroundOrderTrade/manualMatchPlanItem`, {
    method: 'post',
    json,
  });
}

export function searchRecent(areaCode: any): FetchPromise<any> {
  return fetch(`/api/tender/v1/receiveAddress/searchRecent/${areaCode}`, {
    method: 'get',
  });
}

export function getCategory(json): FetchPromise<any> {
  return fetch(`/api/mall/v1/category/get`, {
    method: 'POST',
    json,
  });
}

export function updateLangeNetPrice(json): FetchPromise<any> {
  return fetch(`/api/material/v1/lange/updateLangeNetPrice`, {
    method: 'POST',
    json,
  });
}

export function agreementByLog(snapshotSysNo: string): FetchPromise<any> {
  return fetch(`/api/mall/v1/trade-agreement/log-to-agreement/${snapshotSysNo}`, {
    method: 'GET',
  });
}

export function getCorpBankProduct(orgSysNo): FetchPromise<any> {
  return fetch(`/api/mall/v1/purchaser/trade/getCorpBankProduct/${orgSysNo}`, {
    method: 'POST',
  });
}

export function getFinancingCapitalSource(bankProductSysNo): FetchPromise<any> {
  return fetch(`/api/mall/v1/purchaser/trade/getFinancingCapitalSource`, {
    method: 'POST',
    json: { bankProductSysNo },
  });
}

export function calculateFactorInterest(
  billEndDate,
  fundingPartiesSysNo,
  paymentAmount,
): FetchPromise<any> {
  return fetch(`/api/mall/v1/purchaser/trade/calculateFactorInterest`, {
    method: 'POST',
    json: { billEndDate, fundingPartiesSysNo, paymentAmount },
  });
}

export async function getAreamoduleDetail(sysNo: string) {
  return await fetch(`/api/mall/v1/product/areamodule/detail/${sysNo}`, {
    method: 'GET',
    wantError: true,
  });
}

export async function getReceivingAuditAndConfirmDimension() {
  return await fetch('/api/tender/v1/common/getReceivingAuditAndConfirmDimension', {
    method: 'GET',
  });
}

type CheckInvoiceParams =
  | {
      taxCode: string | number;
      needTianYanCha: boolean;
      title?: never;
    }
  | {
      title: string | number;
      needTianYanCha: boolean;
      taxCode?: never;
    };

export async function getInvoiceInfo(data: CheckInvoiceParams) {
  return await fetch('/api/mall/v1/organization/getInvoiceTitleAndTaxCode/', {
    json: data,
    method: 'POST',
  });
}
/**
 * 获取运费配置开关
 */
export async function selectFreightSwitchConfig() {
  return await fetch(`/api/mall/v1/tenant/customization/config/selectFreightSwitchConfigByKey`, {
    method: 'GET',
  });
}

export async function apiGetOrderStatusCount() {
  return await fetch(`/api/tender/v1/purchaser/orderTrade/mall/queryOrderStatusCount`, {
    method: 'POST',
  });
}

export async function apiGetProductDetail(option) {
  return await fetch(`/api/mall/v1/mallSku/getDetail`, {
    ...option,
    method: 'POST',
  });
}

export async function apiGetProductList(option) {
  return await fetch(`/api/mall/v1/mallSkuList/searchMallSkuList`, {
    ...option,
    method: 'POST',
  });
}

export async function apiGetManufacturerSupplyAgreement(option) {
  return await fetch(`/api/mall/v1/mallSku/selectManufacturerSupplyAgreement`, {
    method: 'GET',
    ...option,
  });
}

export async function apiGetSkuAgreementPriceForList(option) {
  return await fetch(`/api/mall/v1/mallSku/getSkuAgreementPriceForList`, {
    ...option,
    method: 'POST',
  });
}

export async function apiGetAvailableSkuAgreement(option) {
  return await fetch(`/api/mall/v1/mallSkuList/getAvailableSkuAgreement`, {
    ...option,
    method: 'POST',
  });
}

export async function apiGetAgreement(sysNo: string) {
  return await fetch(`/api/mall/v1/trade-agreement/purchaser/ec/${sysNo}`, {
    method: 'GET',
    wantError: true,
  });
}

export async function apiGetPricingAgreement(sysNo: string) {
  return await fetch(`/api/mall/v1/trade-agreement/purchaser/v2/ec/child/detail/${sysNo}`, {
    method: 'GET',
    wantError: true,
  });
}

export async function apiGetAgreementPassword(sysNo: string) {
  return await fetch(`/api/mall/v1/trade-agreement/purchaser/password-info/${sysNo}`, {
    method: 'GET',
    wantError: true,
  });
}
export async function apiSubmitAgreementPassword(option) {
  return await fetch('/api/ifs/v1/auth/subject/authorize', {
    ...option,
    method: 'POST',
  });
}
export async function apiGetAreamodule(sysNo: string) {
  return await fetch(`/api/mall/v1/product/areamodule/detail/${sysNo}`, {
    method: 'GET',
  });
}

export async function apiQueryToQiDianParam(option) {
  return await fetch(`/api/qid/v1/common/loginCustomerService`, {
    ...option,
    method: 'POST',
  });
}

export async function apiUpdateLangeNetPrice(option) {
  return await fetch('/api/material/v1/lange/updateLangeNetPrice', {
    ...option,
    method: 'POST',
  });
}

export async function apiQueryMmuSkuList(option) {
  return await fetch('/api/mall/v1/mallSku/getSkuList', {
    ...option,
    method: 'POST',
  });
}
export async function apiQueryAgreementList(option) {
  return await fetch('/api/mall/v1/mallSku/searchPurchaseAgreementList', {
    ...option,
    method: 'POST',
  });
}

export async function apiQueryContractList(option) {
  return await fetch('/api/mall/v1/mallSku/searchPurchaseContractList', {
    ...option,
    method: 'POST',
  });
}

export function apiConcreteBuyOrderAgain(option) {
  return fetch('/api/mall/v1/mallSku/buyOrderAgain', {
    ...option,
    method: 'POST',
  });
}

export function apiSearchUseLocation(option) {
  return fetch('/api/tender/v1/purchaser/backGroundOrderTrade/searchUseLocation', {
    ...option,
    method: 'POST',
  });
}

export function apiConcreteSupplierSearch(option) {
  return fetch('/api/tender/v1/supplier/search', {
    ...option,
    method: 'POST',
  });
}

interface GeocodeProps {
  addressDetail: string;
  city?: string;
  sig?: string;
  output?: string;
  callback?: Function;
}
interface Geocode {
  country: string;
  province: string;
  city: string;
  citycode: number;
  district: string;
  street: string;
  number: string;
  adcode: string;
  location: string;
  level: number;
}
interface GeocodeResult {
  status: '0' | '1';
  count: number;
  info: string;
  geocodes?: Array<Geocode>;
}

export async function getGeocodeFromAddress(json: GeocodeProps) {
  return responseInterceptor<GeocodeResult>(
    fetch('/api/ifs/v2/gdapi/getOriginLocation', {
      method: 'POST',
      json,
    }),
  );
}
export async function getAreaByGeo(location: string) {
  return responseInterceptor(
    fetch('/api/ifs/v1/basis/area/getAreaByGeo', {
      method: 'GET',
      query: { location },
    }),
  );
}

export function apiCheckOrganizationOverdue(query?: any): FetchPromise<any> {
  return fetch('/api/mall/v1/purchaser/trade/checkOrganizationOverdue', {
    method: 'GET',
    query,
  });
}

export function apiCheckTradeAgreementNotice(json) {
  return fetch('/api/mall/v1/purchaser/tradeDetail/checkTradeAgreementNotice', {
    json,
    method: 'POST',
  });
}

// 获取商城页脚配置信息
export async function getMallDataConfigList() {
  const res = await fetch(`/api/mall/v1/mall/getMallDataConfigList`, {
    method: 'GET',
  });
  return res;
}
